import { render } from "./nav-item.vue?vue&type=template&id=207a6a0b&scoped=true"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"

import "./nav-item.vue?vue&type=style&index=0&id=207a6a0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207a6a0b"]])

export default __exports__